import { useQueryParams } from './utils/usequeryparams';
import { useDispatch, useSelector } from 'react-redux';
import { setAppState, triggerModal } from './redux/actions/appState';
import Form from './components/form';
import useDeepCompareEffect from 'use-deep-compare-effect';
import Loading from './components/Loading/Loading';

const App = () => {
  const dispatch = useDispatch();
  const queryParams = useQueryParams(window.location.search);
  const language = queryParams?.language || 'en';
  const token = queryParams?.token;
  const appVersion = queryParams?.appVersion;
  const subscriptionId = queryParams?.subscriptionId;
  const signature = queryParams?.signature;
  const { isLoading, cashedLanguage } = useSelector((state) => ({
    isLoading: state?.checkout?.isLoading,
    cashedLanguage: state?.appState?.language,
  }));
  useDeepCompareEffect(() => {
    if (queryParams?.message) {
      if (cashedLanguage === 'en') {
        dispatch(triggerModal(true, decodeURIComponent(queryParams?.message)));
      } else {
        dispatch(
          triggerModal(true, decodeURIComponent(queryParams?.ar_message)),
        );
      }
    } else if (subscriptionId) {
      dispatch(
        setAppState({
          subscriptionId,
          language,
          token,
          appVersion,
          signature,
        }),
      );
    }
  }, [queryParams, dispatch, language]);

  return (
    <>
      <Loading visible={isLoading} />
      <Form />
    </>
  );
};

export default App;
